const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://pprodecable.ulr9561.tech'

interface FetchOptions extends RequestInit {
  headers?: Record<string, string>
}

export const apiFetch = async <T = any>(
  endpoint: string,
  options: FetchOptions = {}
): Promise<T> => {
  const url = `${API_BASE_URL}${endpoint}`
  
  const defaultOptions: FetchOptions = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  }

  try {
    const response = await fetch(url, defaultOptions)
    
    // Vérifier si la réponse est OK
    if (!response.ok) {
      let errorMessage = `Erreur ${response.status}`

      if (response.status === 401 && !endpoint.startsWith('/api/auth/')) {
        window.location.replace('/')
      }
      
      const responseClone = response.clone()
      try {
        const errorData = await response.json()
        errorMessage = errorData.error || errorData.message || errorMessage
      } catch {
        errorMessage = await responseClone.text() || errorMessage
      }
      
      throw new Error(errorMessage)
    }
    
    // Vérifier le type de contenu
    const contentType = response.headers.get('content-type')
    if (contentType && contentType.includes('application/json')) {
      return await response.json()
    }

    return (await response.text()) as unknown as T
  } catch (error) {
    if (error instanceof Error) {
      throw error
    }
    throw new Error('Une erreur réseau est survenue')
  }
}

export { API_BASE_URL }
